import { FC } from 'react';
import NumberInterval from '../NumberInterval';
import SearchFormItem from './subpage/searchFormItem';
import { NumberIntervalProps } from '../NumberInterval/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormNumberIntervalProps extends BaseSearchFormItemProps {
  /** NumberInterval Props */
  numberIntervalProps?: NumberIntervalProps;
}
/** 数字区间 */
export const SearchFormNumberInterval: FC<SearchFormNumberIntervalProps> = props => {
  const {
    numberIntervalProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || numberIntervalProps?.disabled}
      name={name}
      label={label}
      rules={rules}
    >
      <NumberInterval
        test-id={`${testId}-${name}`}
        disabledBorder
        {...numberIntervalProps}
        disabled={isDetail || numberIntervalProps?.disabled}
      />
    </SearchFormItem>
  );
};

SearchFormNumberInterval.displayName = SearchFormItemEnum.SearchFormNumberInterval;

export default SearchFormNumberInterval;
